import { Pipe, PipeTransform } from '@angular/core';
import { commas } from '@helpers';

/* Agrega comas de separación en los números */

@Pipe({
  name: 'commas',
  standalone: true,
})
export class CommasPipe implements PipeTransform {
  transform(value: string | number): string | number {
    return commas(value);
  }
}
